import React from "react";
import { authPaymentTypes } from "../parent/data/auth-payment-types";
import { EditOrCancelContent } from "./edit-or-cancel-content.component";
import AutoPayNotEligibleCallUs from "./autopay-not-eligible-call-us";
import { LoanDetailsContent } from "./loan-details-content.component";
import { PaymentTypeContent } from "./payment-type-content.component";
import { PayoffLetterContent } from "./payoff-letter-content.component";
import IneligibleSkipContent from "./ineligible-skip-content.component";

const AuthPaymentModal = (props) => {
  let showCloseIcon = true;

  let ModalContentToDisplay = PaymentTypeContent;

  // For simplicity, we should try and keep the modal content dependent almost exclusively on
  // different parent modalState payment types that get set in the loan card payment buttons

  switch (props.paymentType) {
    case authPaymentTypes.valid.Recurring:
      if (props.loan.RecurringPayment) {
        ModalContentToDisplay = EditOrCancelContent;
      }
      break;
    case authPaymentTypes.invalid.IneligibleSkip:
      ModalContentToDisplay = IneligibleSkipContent;
      break;
    case authPaymentTypes.invalid.IneligibleRecurring:
      ModalContentToDisplay = () => (
        <div>To edit or cancel your recurring payments, call us at 888.267.7200.</div>
      );
      break;
    case authPaymentTypes.invalid.OverdueRecurring:
      ModalContentToDisplay = () => (
        <div>This loan is past due. Please make a payment before setting up AutoPay.</div>
      );
      break;
    case authPaymentTypes.invalid.ZeroBalance:
      ModalContentToDisplay = () => (
        <div>The current balance on this loan is $0.00. There is nothing to pay at this time.</div>
      );
      break;
    case authPaymentTypes.invalid.RecurringCreditCard:
      ModalContentToDisplay = () => (
        <div>
          Recurring payments can be set up by logging in to your credit card portal. Please go to
          your Accounts and click on your Credit Card to be taken to your credit card portal.
        </div>
      );
      break;
    case authPaymentTypes.invalid.PayoffPending:
      ModalContentToDisplay = () => (
        <div>
          Payments cannot be made at this time because there is a pending transaction to pay off
          this loan. If you have any questions, please give us a call at 888.267.7200.
        </div>
      );
      break;
    case authPaymentTypes.other.PayoffLetter:
      ModalContentToDisplay = PayoffLetterContent;
      break;
    case authPaymentTypes.other.LoanDetails:
      ModalContentToDisplay = LoanDetailsContent;
      break;
  }

  const closeModal = () => {
    props.hideModal();
  };

  return (
    <div className={`${props.show ? "active popup-modal loading-modal" : ""}`}>
      <div className="dark-bg"></div>
      <div className="modal px-1" style={{ minHeight: "fit-content", position: "fixed" }}>
        <div class="modal-container py-5 px-3 m-auto" style={{ maxWidth: "90%" }}>
          <button
            onClick={closeModal}
            className="close-icon"
            style={{ visibility: showCloseIcon ? "visible" : "hidden" }}
          >
            <i class="material-icons">close</i>
          </button>
          <ModalContentToDisplay {...props} closeModal={closeModal} />
        </div>
      </div>
    </div>
  );
};

export default AuthPaymentModal;



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/modal/auth-payment-modal.component.js